import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef, OnInit, inject } from '@angular/core';
import { ControlValueAccessor, FormControl, ControlContainer, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

type onChangeCallback = (value: unknown) => unknown;
type onTouchCallback = (value: unknown) => unknown;

@Component({
    selector: 'app-text-input',
    templateUrl: './text-input.component.html',
    styleUrls: ['./text-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule, TranslatePipe],
})
export class TextInputComponent implements ControlValueAccessor, OnInit {
    private readonly controlContainer = inject(ControlContainer);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    @Input({ required: true }) controlName!: string;
    @Input({ required: true }) label!: string;
    @Input() type = 'text';
    @Input() required = false;

    protected disabled?: boolean;
    protected inputValue: unknown = '';

    control!: FormControl;

    ngOnInit(): void {
        this.control = <FormControl>this.controlContainer.control!.get(this.controlName);
    }

    get value(): unknown {
        return this.inputValue;
    }

    set value(value: unknown) {
        if (value !== this.inputValue) {
            this.inputValue = value;
            this.onChange(value);
            this.onTouch(value);
        }
    }

    writeValue(value: unknown): void {
        if (value !== this.inputValue) {
            this.inputValue = value;
            this.changeDetectorRef.detectChanges();
        }
    }

    registerOnChange(fn: onChangeCallback): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: onTouchCallback): void {
        this.onTouch = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onChange: onChangeCallback = (): void => {
        return;
    };

    onTouch: onTouchCallback = (): void => {
        return;
    };

    onClick(): void {
        this.onChange(this.inputValue);
    }
}
